/* global Vue */
const Message = Vue.prototype.$message
/**
 * @description 组件适用端的提示函数
 * @param {String} useProjectList  适用端的list，例如['mall', 'purchaser', 'supplier']
 */
export function componentMessage(useProjectList = [], componentName = '') {
  let project = window.fe.project
  if (!useProjectList.find(pr => pr === project)) {
    console.log(componentName + '组件目前只适用于' + useProjectList.join('、') + '等项目')
    if (process.env.NODE_ENV !== 'production') {
      return Message.error(componentName + '组件目前只适用于' + useProjectList.join('、') + '等项目')
    }
  }
}
